import React from "react";
import { connect } from "react-redux";

import * as actions from "../../store/actions";

import Button from "../../components/formElements/button/Button";
import SideContent from "../../layout/Registration/SideContent";

const NotFound = ({ logout }) => {
  return (
    <div className="row m-0 p-0">
      <div className="col-md-6">
        <SideContent notFound />
      </div>
      <div className="col-md-6">
        <div
          className="container"
          style={{ verticalAlign: "middle", marginTop: "30vh", maxWidth: 400 }}
        >
          <h2 className="auth-header mb-5">Oops!</h2>
          <p className="mb-5">
            We can’t seen to find the page you’re looking for. <br />
            Try going back to Sign In.
          </p>
          <div>
            <Button
              label={"Back to Sign In"}
              className="mb-4"
              onClick={() => {
                logout();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default connect(undefined, mapDispatchToProps)(NotFound);
